'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', 'TaxService',
                function($scope, $routeParams, $window, TaxService) {
                    $scope.taxes = [];
                    TaxService.api.get({
                                           filters: [`'status' EQ 'ENABLED'`],
                                           sorts: ['name:ASC'],
                                       }, (data) => $scope.taxes = data._embedded);
                }];
